import { CopyPasteGeneric } from './copy-paste-generic.js';
import { CopyPasteWebkit } from './copy-paste-webkit.js';
import { CopyPasteNormalizer } from './copy-paste-normalizer.js';


export function CopyPaste (pEditor)
{
  this.generic = new CopyPasteGeneric(pEditor, this);
  this.webkit = new CopyPasteWebkit(pEditor, this);
  this.normalizer = new CopyPasteNormalizer(pEditor, this);


  this.convertPastePlainText = (content) =>
  {
    let match;

    match = content.match(/\r?\n/);

    if (match)
    {
      content = content.replace(/(\r?\n)/g, '</p>$1<p>');
      content = match[0] + '<p>' + content + '</p>' + match[0];
    }

    return content;
  };


  this.removeSystemComponents = () =>
  {
    setTimeout(removeSystemComponentsDo, 11);
  };


  function removeSystemComponentsDo ()
  {
    let i,
        elements;

    elements = pEditor.iFrameDoc.body.querySelectorAll('DIV[data-componentId], DIV[data-editableArea]');

    for (i = elements.length; i--;)
    {
      elements[i].outerHTML = elements[i].innerHTML;
    }
  }


  function removePasteContainers ()
  {
    let i,
        pasteContainers = pEditor.iFrameDoc.body.querySelectorAll('[data-wawebkitpastecontainer]');

    if (pasteContainers)
    {
      for (i = pasteContainers.length; i--;)
      {
        if (pasteContainers[i] && pasteContainers[i].parentNode)
        {
          pasteContainers[i].parentNode.removeChild(pasteContainers[i]);
        }
      }
    }
  }


  function removePasteMarkers ()
  {
    let i,
        markers = pEditor.iFrameDoc.body.querySelectorAll('INPUT[data-waiepastemarkerstart], INPUT[data-waiepastemarkerend]');

    if (markers)
    {
      for (i = markers.length; i--;)
      {
        if (markers[i] && markers[i].parentNode)
        {
          markers[i].parentNode.removeChild(markers[i]);
        }
      }
    }
  }


  function removeCopyMarker ()
  {
    let i,
        elements = pEditor.iFrameDoc.body.querySelectorAll('[data-wacopycontent]');

    for (i = elements.length; i--;)
    {
      elements[i].removeAttribute('data-wacopycontent');
    }
  }


  this.removeWebkitCopyMarker = () =>
  {
    let i,
        elements = pEditor.iFrameDoc.body.querySelectorAll('DIV[data-wawebkitcopycontainer], ABBR[data-wawebkitcopymarker]');

    for (i = elements.length; i--;)
    {
      if (elements[i] && elements[i].parentNode)
      {
        elements[i].parentNode.removeChild(elements[i]);
      }
    }
  };


  this.checkPasteContainersAndMarkers = (content) =>
  {
    let reContainer = /data-wawebkitpastecontainer/i,
        reStartMarker = /data-waiepastemarkerstart/i,
        reEndMarker = /data-waiepastemarkerend/i,
        reCopyMarker = /data-wa(?:webkit|iegecko)copymarker/i,
        ret = false;

    if (content)
    {
      if (BEditor.browser.isWebKit && reContainer.test(content))
      {
        removePasteContainers();
        ret = true;
      }

      if ((BEditor.browser.isIE || BEditor.browser.isGecko) && (reStartMarker.test(content) || reEndMarker.test(content)))
      {
        removePasteMarkers();
        ret = true;
      }

      if (reCopyMarker.test(content))
      {
        removeCopyMarker();
        ret = true;
      }
    }

    return ret;
  };


  this.showAutoCleaningMessage = () =>
  {
    if (BEditor.AdminPanel)
    {
      BEditor.AdminPanel.showNotification({html: 'We have cleaned up some formatting from pasted text.', type: BEditor.AdminPanel.NotificationType.Information, autoClosing: true });
    }
  };


  this.hideAutoCleaningMessage = () =>
  {
    if (BEditor.AdminPanel)
    {
      BEditor.AdminPanel.hideAllNotification();
    }
  };


  this.revertAutoCleaning = () =>
  {
    pEditor.undoRedo.execUndoRedo({}, 'undo');
    pEditor.pThis.focus();
    pEditor.range.restore();
  };


  this.removePasteContainers = removePasteContainers;
  this.removeCopyMarker = removeCopyMarker;
}